import events from './events'
import message from './message'
import sent from './sent'
import internal from './internal'

export default {
  name: 'Message',
  path: 'message',
  meta: {
    label: 'messenger',
    auth: 'message'
  },
  component: {
    name: 'Messanger',
    render(c) {
      return c('router-view')
    }
  },
  children: [events, message, sent, internal]
}
